import { MutableRefObject } from "react";

const getElementPosition = (element: HTMLElement) => element.offsetTop;

interface IProps {
  ref: MutableRefObject<HTMLElement | null>;
  duration: number;
}

export const scrollTo = ({ ref, duration = 3000 }: IProps) => {
  const initialPosition = window.scrollY;
  const element = ref.current;
  if (!element) {
    return;
  }

  animateScroll({
    targetPosition: getElementPosition(element),
    initialPosition,
    duration,
  });
};

const pow = Math.pow;
function easeOutQuart(x: number) {
  return 1 - pow(1 - x, 4);
}

interface IAnimationProps {
  targetPosition: number;
  initialPosition: number;
  duration: number;
}

export function animateScroll({
  targetPosition,
  initialPosition,
  duration,
}: IAnimationProps) {
  let start: number | undefined;
  let position;
  let animationFrame: number;

  const requestAnimationFrame = window.requestAnimationFrame;
  const cancelAnimationFrame = window.cancelAnimationFrame;

  const maxAvailableScroll =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;

  const amountOfPixelsToScroll = initialPosition - targetPosition;

  function step(timestamp: number) {
    if (start === undefined) {
      start = timestamp;
    }

    const elapsed = timestamp - start;
    const relativeProgress = elapsed / duration;
    const easedProgress = easeOutQuart(relativeProgress);
    position =
      initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);
    window.scrollTo(0, position + 30);

    if (
      initialPosition !== maxAvailableScroll &&
      window.scrollY === maxAvailableScroll
    ) {
      cancelAnimationFrame(animationFrame);
      return;
    }

    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    }
  }

  animationFrame = requestAnimationFrame(step);
}



// WEBPACK FOOTER //
// ./src/presentation/scroll_to.tsx